import cls from "./FormTitle.module.scss";

export const FormTitle = ({ children }) => {
  return <h2 className={cls.title}>{children}</h2>;
};
